import { useQuery, UseQueryResult } from "@tanstack/react-query";
import getAPI from "../services/api";

const useFlags = ({
  page = 1,
  pageSize = 100,
  filters = {},
  sort = {},
  enabled = true,
  csv = false,
}: {
  page?: number;
  pageSize?: number;
  filters?: any;
  sort?: any;
  enabled?: boolean;
  csv?: boolean;
}): UseQueryResult<any> => {
  return useQuery(
    ["flags", page, pageSize, filters, sort, csv],
    async () => {
      const api = await getAPI();
      const { data } = await api.get("/flags", {
        params: {
          csv,
          pagination: { pageSize, page },
          filters,
          sort,
        },
      });
      return data;
    },
    { enabled }
  );
};

export default useFlags;
